// extracted by mini-css-extract-plugin
module.exports = {"contacts":"SupportContacts_contacts__B0oTi","addContact":"SupportContacts_addContact__3qZGh"};